/* ==========================================================================
   Matcha Studio — JavaScript du thème
   Aucune dépendance externe. Tout est en vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* --- Utilitaires -------------------------------------------------------- */
  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function on(el, evt, handler) {
    if (el) el.addEventListener(evt, handler);
  }
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = theme.moneyFormat || '{{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, amount.replace('.', ','));
  }
  function trapScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  /* --- Header collant ----------------------------------------------------- */
  function initHeader() {
    var wrapper = $('[data-header-wrapper]');
    if (!wrapper) return;
    var onScroll = function () {
      wrapper.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Menu mobile -------------------------------------------------------- */
  function initMenuDrawer() {
    var drawer = $('[data-menu-drawer]');
    if (!drawer) return;

    var open = function () {
      drawer.classList.add('is-open');
      trapScroll(true);
    };
    var close = function () {
      drawer.classList.remove('is-open');
      trapScroll(false);
    };

    $$('[data-menu-open]').forEach(function (btn) { on(btn, 'click', open); });
    $$('[data-menu-close]', drawer).forEach(function (btn) { on(btn, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* --- Modale de recherche ------------------------------------------------ */
  function initSearch() {
    var modal = $('#SearchModal');
    if (!modal) return;

    var open = function () {
      modal.hidden = false;
      trapScroll(true);
      var input = $('#SearchInput', modal);
      if (input) setTimeout(function () { input.focus(); }, 50);
    };
    var close = function () {
      modal.hidden = true;
      trapScroll(false);
    };

    $$('[data-search-open]').forEach(function (btn) { on(btn, 'click', open); });
    $$('[data-search-close]', modal).forEach(function (btn) { on(btn, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* --- Accordéons --------------------------------------------------------- */
  function initAccordions(scope) {
    $$('[data-accordion-toggle]', scope).forEach(function (toggle) {
      if (toggle.dataset.bound) return;
      toggle.dataset.bound = 'true';
      on(toggle, 'click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.dataset.open = expanded ? 'false' : 'true';
      });
    });
  }

  /* --- Onglets (FAQ par catégorie) ---------------------------------------- */
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach(function (group) {
      var tabs = $$('[data-tab]', group);
      var panels = $$('[data-tab-panel]', group);
      tabs.forEach(function (tab) {
        on(tab, 'click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
          panels.forEach(function (panel) {
            panel.hidden = panel.dataset.tabPanel !== tab.dataset.tab;
          });
        });
      });
    });
  }

  /* --- Carrousels --------------------------------------------------------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach(function (slider) {
      var id = slider.dataset.slider;
      var prev = $('[data-slider-prev="' + id + '"]');
      var next = $('[data-slider-next="' + id + '"]');
      var step = function () {
        var first = slider.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : 320;
      };
      on(prev, 'click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* --- Carrousel d'images produit ----------------------------------------- */
  function initMediaSliders(scope) {
    $$('[data-media-slider]', scope).forEach(function (slider) {
      if (slider.dataset.bound) return;
      slider.dataset.bound = 'true';

      var progress = $('[data-media-progress="' + slider.dataset.mediaSlider + '"]');
      if (!progress) return;
      var segments = $$('.media-progress__segment', progress);

      var update = function () {
        var index = Math.round(slider.scrollLeft / slider.clientWidth);
        segments.forEach(function (segment, i) {
          segment.classList.toggle('is-active', i === index);
        });
      };

      slider.addEventListener('scroll', function () {
        window.clearTimeout(slider._scrollTimer);
        slider._scrollTimer = window.setTimeout(update, 60);
      }, { passive: true });

      segments.forEach(function (segment, i) {
        segment.addEventListener('click', function () {
          slider.scrollTo({ left: slider.clientWidth * i, behavior: 'smooth' });
        });
      });
    });
  }

  /* --- Animations à l'apparition ------------------------------------------ */
  function initAnimations(scope) {
    if (!document.body.classList.contains('animations-enabled')) return;
    if (!('IntersectionObserver' in window)) {
      $$('[data-animate]', scope).forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    $$('[data-animate]', scope).forEach(function (el) {
      if (el.dataset.observed) return;
      el.dataset.observed = 'true';
      observer.observe(el);
    });
  }

  /* --- Sélecteur de quantité ---------------------------------------------- */
  function initQuantity(scope) {
    $$('[data-quantity]', scope).forEach(function (wrapper) {
      if (wrapper.dataset.bound) return;
      wrapper.dataset.bound = 'true';
      var input = $('input', wrapper);
      $$('[data-quantity-change]', wrapper).forEach(function (btn) {
        on(btn, 'click', function () {
          var delta = parseInt(btn.dataset.quantityChange, 10);
          var value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + delta);
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --- Sélecteur de variante ---------------------------------------------- */
  function initVariantPickers(scope) {
    $$('[data-variant-picker]', scope).forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = 'true';

      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var sectionId = picker.dataset.variantPicker;
      var form = $('[data-product-form="' + sectionId + '"]');
      var priceEl = $('[data-product-price="' + sectionId + '"]');
      var idInput = form ? $('input[name="id"]', form) : null;
      var submit = form ? $('[data-add-to-cart]', form) : null;

      var currentOptions = function () {
        return $$('[data-option-index]', picker).map(function (group) {
          var selected = $('.is-selected', group);
          return selected ? selected.dataset.value : null;
        });
      };

      var update = function () {
        var options = currentOptions();
        var match = variants.filter(function (variant) {
          return options.every(function (value, index) {
            return value === null || variant.options[index] === value;
          });
        })[0];

        if (!match) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = theme.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl && match.price != null) {
          priceEl.innerHTML =
            '<span class="' + (match.compare_at_price > match.price ? 'price__sale' : '') + '">' +
            formatMoney(match.price) + '</span>' +
            (match.compare_at_price > match.price
              ? ' <s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>'
              : '');
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? theme.strings.addToCart : theme.strings.soldOut;
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      };

      $$('[data-option-index]', picker).forEach(function (group) {
        $$('[data-value]', group).forEach(function (button) {
          on(button, 'click', function () {
            $$('[data-value]', group).forEach(function (b) { b.classList.remove('is-selected'); });
            button.classList.add('is-selected');
            update();
          });
        });
      });
    });
  }

  /* --- Panier ------------------------------------------------------------- */
  var CartDrawer = {
    el: function () { return $('[data-cart-drawer]'); },
    open: function () {
      var drawer = CartDrawer.el();
      if (!drawer) return;
      drawer.classList.add('is-open');
      trapScroll(true);
    },
    close: function () {
      var drawer = CartDrawer.el();
      if (!drawer) return;
      drawer.classList.remove('is-open');
      trapScroll(false);
    },
    refresh: function () {
      return fetch(routes.cart_url + '?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer]');
          var current = CartDrawer.el();
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            CartDrawer.bind();
          }
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        });
    },
    bind: function () {
      var drawer = CartDrawer.el();
      if (!drawer) return;
      $$('[data-cart-close]', drawer).forEach(function (btn) { on(btn, 'click', CartDrawer.close); });
      bindCartLineActions(drawer);
      initQuantity(drawer);
    }
  };

  function bindCartLineActions(scope) {
    $$('[data-cart-remove]', scope).forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        changeLine(btn.dataset.cartRemove, 0);
      });
    });
    $$('[data-cart-quantity]', scope).forEach(function (input) {
      on(input, 'change', function () {
        changeLine(input.dataset.cartQuantity, parseInt(input.value, 10));
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          CartDrawer.refresh();
        }
      })
      .catch(function () { window.location.href = routes.cart_url; });
  }

  function initAddToCart() {
    $$('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';

      on(form, 'submit', function (e) {
        if (theme.cartType !== 'drawer') return;
        e.preventDefault();

        var button = $('[data-add-to-cart]', form);
        var label = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = '…';
        }

        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function () {
            return CartDrawer.refresh();
          })
          .then(function () {
            CartDrawer.open();
          })
          .catch(function () {
            window.location.href = routes.cart_url;
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = label;
            }
          });
      });
    });

    $$('[data-cart-open]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      on(btn, 'click', function (e) {
        // Sans tiroir disponible, on laisse le lien mener à la page panier :
        // un clic ne doit jamais rester sans effet.
        if (theme.cartType !== 'drawer' || !CartDrawer.el()) return;
        e.preventDefault();
        CartDrawer.open();
      });
    });
  }

  /* --- Suivi de commande --------------------------------------------------- */
  function initTracking(scope) {
    $$('[data-tracking]', scope).forEach(function (bloc) {
      if (bloc.dataset.bound) return;
      bloc.dataset.bound = 'true';

      var champ = $('[data-tracking-input]', bloc);
      var bouton = $('[data-tracking-submit]', bloc);
      var message = $('[data-tracking-message]', bloc);
      if (!champ || !bouton) return;

      var suivre = function () {
        var numero = (champ.value || '').trim();

        if (!numero) {
          if (message) {
            message.textContent = champ.dataset.trackingError || '';
            message.hidden = false;
          }
          champ.focus();
          return;
        }

        if (message) message.hidden = true;

        var modele = champ.dataset.trackingUrl || '';
        if (modele.indexOf('NUMERO') === -1) return;

        var url = modele.replace('NUMERO', encodeURIComponent(numero));
        if (champ.dataset.trackingTarget === 'self') {
          window.location.href = url;
        } else {
          window.open(url, '_blank', 'noopener');
        }
      };

      on(bouton, 'click', suivre);
      on(champ, 'keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          suivre();
        }
      });
    });
  }

  /* --- Formulaire d'avis --------------------------------------------------- */
  function initReviewForm(scope) {
    $$('[data-review-form]', scope).forEach(function (modal) {
      if (modal.dataset.bound) return;
      modal.dataset.bound = 'true';

      var id = modal.dataset.reviewForm;
      var open = function () {
        modal.classList.add('is-open');
        trapScroll(true);
      };
      var close = function () {
        modal.classList.remove('is-open');
        trapScroll(false);
      };

      $$('[data-review-open="' + id + '"]').forEach(function (btn) { on(btn, 'click', open); });
      $$('[data-review-close]', modal).forEach(function (btn) { on(btn, 'click', close); });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });

      // Après envoi, Shopify recharge la page : on rouvre pour montrer la confirmation
      if ($('.review-form__success', modal)) open();
    });
  }

  /* --- Pop-up d'accueil ---------------------------------------------------- */
  function initPopup(scope) {
    $$('[data-popup]', scope).forEach(function (popup) {
      if (popup.dataset.bound) return;
      popup.dataset.bound = 'true';

      var cle = 'popup-' + popup.dataset.popupId;
      var frequence = popup.dataset.frequency || 'once';
      var delai = (parseFloat(popup.dataset.delay) || 0) * 1000;
      var editeur = document.documentElement.classList.contains('shopify-design-mode');

      var dejaVu = function () {
        try {
          if (frequence === 'always') return false;
          if (frequence === 'session') return sessionStorage.getItem(cle) === '1';
          return localStorage.getItem(cle) === '1';
        } catch (e) {
          return false;
        }
      };
      var memoriser = function () {
        try {
          if (frequence === 'session') sessionStorage.setItem(cle, '1');
          else if (frequence === 'once') localStorage.setItem(cle, '1');
        } catch (e) {}
      };

      var close = function () {
        popup.classList.remove('is-open');
        trapScroll(false);
        memoriser();
      };

      $$('[data-popup-close]', popup).forEach(function (btn) { on(btn, 'click', close); });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
      });

      // Dans l'éditeur de thème, on l'affiche tout de suite pour pouvoir le régler
      if (editeur) {
        popup.classList.add('is-open');
        return;
      }

      if (dejaVu()) return;
      window.setTimeout(function () {
        popup.classList.add('is-open');
        trapScroll(true);
      }, delai);
    });
  }

  /* --- Compteurs animés ---------------------------------------------------- */
  function initCounters(scope) {
    var counters = $$('[data-counter]', scope);
    if (!counters.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.dataset.counter);
        if (isNaN(target)) return;
        var duration = 1400;
        var start = performance.now();
        var step = function (now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(target * eased);
          el.textContent = value.toLocaleString('fr-FR');
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* --- Initialisation ------------------------------------------------------ */
  function initAll(scope) {
    initAccordions(scope);
    initTabs(scope);
    initSliders(scope);
    initMediaSliders(scope);
    initAnimations(scope);
    initQuantity(scope);
    initVariantPickers(scope);
    initCounters(scope);
    initPopup(scope);
    initReviewForm(scope);
    initTracking(scope);
    initAddToCart();
    bindCartLineActions(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMenuDrawer();
    initSearch();
    CartDrawer.bind();
    initAll(document);
  });

  /* Rechargement des sections dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (event) {
    initHeader();
    initMenuDrawer();
    initSearch();
    initAll(event.target);
  });

  window.theme = Object.assign(theme, { CartDrawer: CartDrawer, initAll: initAll });
})();
